export default function CtaBand() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto relative rounded-lg overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20abstract%20comic%20texture%20banner%20with%20layered%20panel%20shapes%20and%20halftone%20dot%20pattern%2C%20warm%20amber%20coral%20and%20olive%20flat%20color%20blocks%2C%20no%20text%2C%20no%20faces%2C%20editorial%20poster%20illustration%2C%20high%20detail%2C%20harmonious%20composition&width=1920&height=600&seq=cta-manga-band&orientation=landscape"
          alt=""
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/55 to-black/40"></div>
        <div className="relative z-10 px-6 md:px-12 py-12 md:py-16 max-w-2xl">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 leading-snug">
            选好体系与题材，现在就顺着线索开始阅读
          </h2>
          <p className="mt-4 text-sm md:text-base text-background-50/85 leading-relaxed">
            回到分类指南确认你的阅读形态，再按题材标签筛出同类作品，几步之内就能把候选清单缩到个位数。
          </p>
          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <a
              href="#genres"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              <i className="ri-compass-3-line"></i>
              回到分类指南
            </a>
            <a
              href="#recommend"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/10 text-background-50 font-medium whitespace-nowrap cursor-pointer border border-background-50/30 hover:bg-background-50/20 transition-colors"
            >
              <i className="ri-fire-line"></i>
              查看题材推荐
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}